(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["old-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-tabs--hs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  //   const containers = document.querySelectorAll('.--custom-size-chart-container');
    // containers.forEach(container => {
      const firstLevelTabs = document.querySelectorAll('.first-level li');
      const secondLevelTabs = document.querySelectorAll('.second-level li');

      function switchFirstTab(targetId) {
        // Remove active class from all first-level tabs and contents
        firstLevelTabs.forEach(tab => tab.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));

        // Add active class to selected tab and content
        const selectedTab = document.querySelector(`.first-level li[data-tab="${targetId}"]`);
        const selectedContent = document.querySelector(`#content-${targetId}`);
        const selectedHtmImage = document.querySelector(`#htm_img-${targetId}`);
        const htmImages = document.querySelectorAll("[data-htm-image]");
        
        htmImages.forEach(htmImage => {
          htmImage.classList.remove('active');
        })

        if(selectedTab && selectedHtmImage) {
          selectedHtmImage.classList.add('active');
        }
        
        if (selectedTab && selectedContent) {
          selectedTab.classList.add('active');
          selectedContent.classList.add('active');

          // Handle second-level tabs or direct content
          const secondLevel = selectedContent.querySelector('.second-level');
          if (secondLevel && secondLevel.children.length > 0) {
            // Reset all sub-tabs and sub-contents
            secondLevel.querySelectorAll('li').forEach(sub => sub.classList.remove('active'));
            selectedContent.querySelectorAll('.sub-content').forEach(content => content.classList.remove('active'));

            // Activate the first sub-tab and its content
            const firstSubTab = secondLevel.querySelector('li:first-child');
            if (firstSubTab) {
              firstSubTab.classList.add('active');
              const firstSubTabId = firstSubTab.dataset.subtab;
              const firstSubContent = selectedContent.querySelector(`#content-${firstSubTabId}`);
              if (firstSubContent) {
                firstSubContent.classList.add('active');
              }
            }
          } else {
            // No sub-tabs, activate direct content
            const directContent = selectedContent.querySelector('.sub-content');
            if (directContent) {
              directContent.classList.add('active');
            }
          }
        }
      }

      function switchSubTab(subId, parentId) {
        const parentContent = document.querySelector(`#content-${parentId}`);
        if (parentContent) {
          // Remove active class from all sub-tabs and sub-contents
          parentContent.querySelectorAll('.second-level li').forEach(sub => sub.classList.remove('active'));
          parentContent.querySelectorAll('.sub-content').forEach(content => content.classList.remove('active'));

          // Add active class to selected sub-tab and sub-content
          const selectedSub = parentContent.querySelector(`.second-level li[data-subtab="${subId}"]`);
          const selectedSubContent = parentContent.querySelector(`#content-${subId}`);
          
          if (selectedSub && selectedSubContent) {
            selectedSub.classList.add('active');
            selectedSubContent.classList.add('active');
          }
        }
      }

      // Attach event listeners to first-level tabs
      firstLevelTabs.forEach(tab => {
        tab.addEventListener('click', function() {
          switchFirstTab(this.dataset.tab);
        });
      });

      // Attach event listeners to second-level tabs
      secondLevelTabs.forEach(sub => {
        sub.addEventListener('click', function() {
          const parentId = this.closest('.tab-content').id.replace('content-', '');
          switchSubTab(this.dataset.subtab, parentId);
        });
      });

      // Initialize the first tab
      const firstTab = document.querySelector('.first-level li:first-child');
      if (firstTab) {
        switchFirstTab(firstTab.dataset.tab);
      }
    // });
  });

  } catch(e) { console.error(e); }
})();
})();
